module.exports = __webpack_public_path__ + "img/album16_07.c18de546.jpg";